var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-cascader", staticStyle: { position: "relative" } },
    [
      _c("el-cascader", {
        attrs: {
          disabled: _vm.params.disabled,
          options: _vm.params.options,
          filterable: _vm.params.filterable,
          clearable: "",
          placeholder: _vm.params.placeholder
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }